const chunkMapping = {
	"7": [
		6388
	],
	"245": [
		2245
	],
	"388": [
		8098,
		5727,
		9411,
		761
	],
	"488": [
		2488
	],
	"578": [
		5578
	],
	"606": [
		4606
	]
};
const idToExternalAndNameMapping = {
	"761": [
		"default",
		"./routes",
		5707
	],
	"2245": [
		"default",
		"./ContentTiles",
		1779
	],
	"2488": [
		"default",
		"./Amenities",
		4555
	],
	"4606": [
		"default",
		"./Chat",
		7047
	],
	"5578": [
		"default",
		"./Mimo",
		4031
	],
	"5727": [
		"default",
		"./routes",
		8332
	],
	"6388": [
		"default",
		"./Messaging",
		6567
	],
	"8098": [
		"default",
		"./routes",
		9879
	],
	"9411": [
		"default",
		"./Nav",
		2991
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}